import React from 'react';
import { COLORS, UI_SCREEN_STYLES } from '../../styles/UISystem';
import { HeaderChatExample, HeaderProfileExample } from '../../components/UISystem/Headers';
import HeaderConnectionShowcase from '../../components/UISystem/Showcase/HeaderConnectionShowcase';
import HeaderConnectionImageShowcase from '../../components/UISystem/Showcase/HeaderConnectionImageShowcase';
import HeaderConnectionDetailShowcase from '../../components/UISystem/Showcase/HeaderConnectionDetailShowcase';
import IconBack from '../../components/UISystem/Icons/IconBack';

/**
 * HeadersScreen Component
 * 
 * Displays all Header components in the UI System
 */
const HeadersScreen = ({ onBack }) => {
  return (
    <div style={{
      ...UI_SCREEN_STYLES.container,
      backgroundColor: COLORS.LIGHT_GRAY // Light gray background to see white headers clearly
    }}>
      {/* Header */}
      <div style={UI_SCREEN_STYLES.header}>
        <div style={{
          ...UI_SCREEN_STYLES.backButton,
          left: '8px' // Ensure consistent 8px from left across all headers
        }}>
          <IconBack onClick={onBack} />
        </div>
        <div style={UI_SCREEN_STYLES.title}>Headers</div>
      </div>
      
      {/* Content */}
      <div style={{
        ...UI_SCREEN_STYLES.content,
        backgroundColor: COLORS.LIGHT_GRAY
      }}>
        <h2>Legacy Headers</h2>
        <HeaderChatExample />
        <HeaderProfileExample />
        
        <h2>Connection Headers</h2>
        <HeaderConnectionShowcase />

        <h2>Connection Headers with Profile Image</h2>
        <HeaderConnectionImageShowcase />

        <h2>Connection Detail Headers</h2>
        <HeaderConnectionDetailShowcase />
      </div>
    </div>
  );
};

export default HeadersScreen;
